document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[aria-controls][aria-haspopup="dialog"].pdp-trigger').forEach(function (trigger) {
    var modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!modal) return;

    // The modal can be nested inside an animated wrapper (motion-element) that applies
    // a CSS transform for its entrance animation. Any transformed ancestor becomes the
    // containing block for position:fixed children, which breaks full-viewport centering.
    // Move the modal to the end of <body> so it always centers on the whole page.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    trigger.addEventListener('click', function () {
      modal.classList.add('is-open');
    });

    var closeBtn = modal.querySelector('[data-pdp-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        modal.classList.remove('is-open');
      }
    });
  });

  // "See all dimensions" jump-link: opens and scrolls to the Dimensions accordion.
  // Matches any link ending in #dims (e.g. the link pasted into the
  // product.metafields.custom.pdp_dimensions_bar metafield), and finds the
  // Dimensions accordion via its stable [data-dims-jump-target] attribute
  // (its real id is dynamic per block/section instance).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#dims"], a[href="#dims"]');
    if (!link) return;

    var target = document.querySelector('[data-dims-jump-target]');
    if (!target) return;

    e.preventDefault();

    if ('open' in target) {
      target.open = true;
    } else {
      target.setAttribute('open', '');
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Mobile tap feedback for the complementary-slider "Add" button.
  // Touch devices never fire :hover, and iOS Safari does not reliably apply
  // :active either, so a class is toggled on pointer events instead. Delegated
  // from document because product-recommendations re-renders the slider cards.
  var atcSelector = '.product__block--complementary .product-card__atc';
  var atcTapTimer;

  function clearAtcTap() {
    var tapped = document.querySelectorAll('.product-card__atc.is-tapping');
    if (!tapped.length) return;
    clearTimeout(atcTapTimer);
    // Hold the colour for a beat after the finger lifts so the tap is visible.
    atcTapTimer = setTimeout(function () {
      tapped.forEach(function (el) {
        el.classList.remove('is-tapping');
      });
    }, 180);
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType === 'mouse') return;
      var btn = e.target && e.target.closest ? e.target.closest(atcSelector) : null;
      if (!btn) return;
      clearTimeout(atcTapTimer);
      btn.classList.add('is-tapping');
    },
    { passive: true }
  );

  ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (evt) {
    document.addEventListener(evt, clearAtcTap, { passive: true });
  });
});

// ---------------------------------------------------------------------------
// Fullscreen image (PhotoSwipe) close fix — mobile.
//
// Bug: open a gallery image fullscreen, tap X, and the page lands on the
// Configuration section instead of the image. Cause: on close, the theme's
// media-gallery syncs its Swiper (autoHeight: true) to the last-viewed
// fullscreen slide. If that slide's lazy image has not rendered yet, the
// gallery collapses to ~0 height for that reflow, so everything below it
// (the configurator) jumps up into the viewport — and on some closes the
// scroll position itself drifts.
//
// Fix, applied from outside so media-gallery.js stays untouched:
//   1. When the PhotoSwipe overlay (.pswp) is added to <body>, remember the
//      page scroll position and each gallery's current height.
//   2. When it is removed (close finished), pin each gallery to its
//      remembered height via min-height so the layout below cannot move,
//      restore the exact scroll position, and force Swiper to recompute.
//   3. Release the min-height pin once the now-active slide's image has
//      loaded (or after a short safety timeout), recomputing autoHeight so
//      the gallery settles at its natural size.
// MutationObserver callbacks run before the next paint, so the pin is in
// place before the user ever sees a collapsed gallery.
// ---------------------------------------------------------------------------
(function () {
  var savedScrollY = null;
  var savedHeights = null;

  function getGalleries() {
    return Array.prototype.slice.call(document.querySelectorAll('media-gallery'));
  }

  function getSlider(gallery) {
    try {
      if (gallery.sliderInstance && typeof gallery.sliderInstance === 'object' && gallery.sliderInstance.slider) {
        var slider = gallery.sliderInstance.slider;
        if (!slider.destroyed) return slider;
      }
    } catch (e) {}
    return null;
  }

  function refreshSlider(slider) {
    if (!slider) return;
    try {
      if (typeof slider.update === 'function') slider.update();
      if (typeof slider.updateAutoHeight === 'function') slider.updateAutoHeight(0);
    } catch (e) {}
  }

  function onZoomOpened() {
    savedScrollY = window.scrollY;
    savedHeights = getGalleries().map(function (gallery) {
      return gallery.offsetHeight;
    });
  }

  function releaseWhenSettled(gallery, slider) {
    var released = false;
    var release = function () {
      if (released) return;
      released = true;
      gallery.style.minHeight = '';
      refreshSlider(slider);
    };

    var img = null;
    try {
      if (slider && slider.slides && slider.slides[slider.activeIndex]) {
        img = slider.slides[slider.activeIndex].querySelector('img');
      }
    } catch (e) {}

    if (img && !img.complete) {
      img.addEventListener('load', release, { once: true });
      img.addEventListener('error', release, { once: true });
      // Safety: never leave the pin on if the load event is missed.
      setTimeout(release, 1500);
    } else {
      // Image already rendered — just let the current frame paint first.
      setTimeout(release, 250);
    }
  }

  function onZoomClosed() {
    if (savedScrollY === null) return;
    var y = savedScrollY;
    var heights = savedHeights || [];
    savedScrollY = null;
    savedHeights = null;

    getGalleries().forEach(function (gallery, i) {
      var h = heights[i];
      if (h && h > 0) {
        gallery.style.minHeight = h + 'px';
      }
      var slider = getSlider(gallery);
      refreshSlider(slider);
      releaseWhenSettled(gallery, slider);
    });

    // Put the page back exactly where it was before fullscreen opened.
    window.scrollTo({ top: y, left: 0, behavior: 'auto' });
    requestAnimationFrame(function () {
      window.scrollTo({ top: y, left: 0, behavior: 'auto' });
    });
  }

  function isPswpNode(node) {
    return node && node.nodeType === 1 && node.classList && node.classList.contains('pswp');
  }

  function startObserving() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          if (isPswpNode(m.addedNodes[j])) onZoomOpened();
        }
        for (var k = 0; k < m.removedNodes.length; k++) {
          if (isPswpNode(m.removedNodes[k])) onZoomClosed();
        }
      }
    });
    observer.observe(document.body, { childList: true });
  }

  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();

// ---------------------------------------------------------------------------
// Colour change: stop the gallery jumping to a wrong image of the OLD colour.
//
// Bug: pick a different colour and the gallery first slides to a DIFFERENT
// image of the colour you are leaving (~500ms), then the new colour appears.
//
// Cause: media-gallery.js setActiveMedia(variant) does this —
//
//     const mediaId = variant.featured_media.id;
//     let targetIndex = slides.findIndex(s => s.dataset.mediaId == mediaId && !dup);
//     if (targetIndex < 0) {
//       const position = parseInt(variant.featured_media.position) || 1;
//       targetIndex = Math.min(Math.max(position - 1, 0), slides.length - 1);
//     }
//     slider.slideToLoop(targetIndex, 0, false);
//
// It is called the moment the variant changes, via FoxTheme.pubsub.publish
// in product-info.js — the line BEFORE document.dispatchEvent('variant:changed').
// At that point the mounted slides still belong to the outgoing colour, so the
// incoming variant's featured media is not found, findIndex returns -1, and it
// falls back to guessing by POSITION within the product's full media list.
// Applying that position to the old colour's slide list lands on an unrelated
// image (e.g. featured position 3 -> green slide 3). The colour re-render then
// arrives and resets to slide 1, which is the jump-then-switch you see.
//
// Fix, applied from outside so media-gallery.js stays untouched:
//   Wrap setActiveMedia on the media-gallery class and drop the call when the
//   requested media is not actually mounted yet. No guess, no move — the
//   gallery simply holds the current frame. Once the new colour's media is in
//   the DOM the theme calls setActiveMedia again (and runs its own sort /
//   addon filter), the id IS found, and it positions correctly.
//
// Patched on the prototype, so every media-gallery instance is covered,
// including any created later by a section re-render. An earlier attempt
// suppressed slideTo on 'variant:changed' instead; that could never work,
// because pubsub fires first and the jump had already happened.
// ---------------------------------------------------------------------------
(function () {
  var MAX_WAIT_MS = 8000;
  var RETRY_MS = 100;
  var waited = 0;

  function mediaIdOf(slide) {
    return slide && slide.dataset ? slide.dataset.mediaId || slide.dataset.target : null;
  }

  function isMounted(gallery, mediaId) {
    var slider = null;
    try {
      if (gallery.sliderInstance && typeof gallery.sliderInstance === 'object') {
        slider = gallery.sliderInstance.slider;
      }
    } catch (e) {}

    // No slider yet: leave the original alone, it has a non-slider path
    // (sortMediaItems) that must still run.
    if (!slider || slider.destroyed || !slider.slides) return true;

    return Array.prototype.some.call(slider.slides, function (slide) {
      if (slide.classList && slide.classList.contains('swiper-slide-duplicate')) return false;
      return String(mediaIdOf(slide)) === String(mediaId);
    });
  }

  function patch() {
    var MG = window.customElements && window.customElements.get('media-gallery');
    if (!MG || !MG.prototype) return false;
    if (MG.prototype.__ocSetActiveMediaPatched) return true;

    var original = MG.prototype.setActiveMedia;
    if (typeof original !== 'function') return false;

    MG.prototype.setActiveMedia = function (variant) {
      try {
        var mediaId = variant && variant.featured_media && variant.featured_media.id;
        if (mediaId != null && !isMounted(this, mediaId)) {
          // Slides still belong to the outgoing colour. Skipping avoids the
          // position-based guess that causes the visible jump.
          return;
        }
      } catch (e) {
        // Never let the guard break the gallery: fall through to the original.
      }
      return original.apply(this, arguments);
    };

    MG.prototype.__ocSetActiveMediaPatched = true;
    return true;
  }

  // media-gallery.js is loaded by the product section and may register after
  // this file runs, so poll briefly until the class exists.
  if (patch()) return;
  var timer = setInterval(function () {
    waited += RETRY_MS;
    if (patch() || waited >= MAX_WAIT_MS) clearInterval(timer);
  }, RETRY_MS);
})();

// ---------------------------------------------------------------------------
// Ottoman add-on with the module-bundle sofas (Oct 18, 2026).
//
// Bug: pick a layout, select the Ottoman add-on, Add to cart ->
// "Bundle products and add-ons cannot be mixed". The message is Shopify's.
// ProductForm.buildBundledItems (assets/theme.js) sends the ottoman as a
// Shopify cart "add-on" child of the sofa line (parent_id: <sofa variant>).
// Since Oct 17-18 every Domino and Pearl sofa variant is a fixed bundle of
// modules (requires_components), and the Cart API refuses an add-on child on
// a bundle parent.
//
// Fix, applied from outside so theme.js stays untouched: a capture-phase
// submit listener on document runs before the form's own handler, and wraps
// that form's buildBundledItems so the items it returns carry no parent_id.
// The ottoman becomes an ordinary second cart line, which is also what the
// warehouse wants (one line per box on the packing slip). The _addon_ref_key
// and _addon_parent_product_id properties are kept, so the two lines can
// still be tied together; underscore properties stay hidden in the cart.
// Applied per form at submit time, so it covers the main form, the sticky
// ATC bar form, and forms created later by a configurator layout swap.
// ---------------------------------------------------------------------------
(function () {
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.buildBundledItems !== 'function') return;
      if (form.__ocAddonNoParent) return;
      var original = form.buildBundledItems;
      form.buildBundledItems = function (addonVariantId) {
        var items = original.call(form, addonVariantId);
        if (Array.isArray(items)) {
          items.forEach(function (item) {
            if (item && typeof item === 'object' && 'parent_id' in item) delete item.parent_id;
          });
        }
        return items;
      };
      form.__ocAddonNoParent = true;
    },
    true
  );
})();